import React from 'react';
import { ArrowDownIcon, HeartHandshakeIcon } from 'lucide-react';
const scenes = ['Bajar las escaleras con fluidez.', 'Abrir frascos sin pedir ayuda.', 'Caminar por el parque sin pensar en sus rodillas.'];
export function Vision() {
  return <section className="w-full border-y border-teal/10 bg-teal-soft py-16 lg:py-24" data-id="element-164" data-mp="1c56rtyqw0mjy">
      <div className="mx-auto max-w-readable px-6 text-center" data-id="element-165" data-mp="17a17h4d4vfxz">
        <HeartHandshakeIcon className="mx-auto h-10 w-10 text-teal-dark" aria-hidden="true" data-id="element-166" data-mp="23yqq4wwl4cl0" />
        <h2 className="mt-6 font-serif text-3xl font-semibold leading-tight text-teal-dark sm:text-4xl" data-id="element-167" data-mp="1zy6phjcsyqu4">
          Imagine su vida dentro de una semana
        </h2>

        <ul className="mt-10 space-y-4" data-id="element-168" data-mp="1pz7ie57or398">
          {scenes.map(scene => <li key={scene} className="rounded-xl bg-paper/80 px-6 py-5 font-serif text-xl italic text-ink sm:text-2xl" data-id="element-169" data-mp="jim1n1m5eghz">
              {scene}
            </li>)}
        </ul>

        <p className="mt-10 font-sans text-xl leading-relaxed text-teal-dark sm:text-[1.375rem]" data-id="element-170" data-mp="25zbqu4r8mrco">
          Este protocolo no solo quita el dolor:{' '}
          <strong className="font-semibold" data-id="element-171" data-mp="29z2ngp3g41p4">
            le devuelve su independencia
          </strong>
          .
        </p>
        <ArrowDownIcon className="mx-auto mt-10 h-7 w-7 text-teal-dark/60" aria-hidden="true" data-id="element-172" data-mp="2108m6lf66n58" />
      </div>
    </section>;
}